module.exports = function() {

    showHideClauses();

    function showHideClauses(){

        var $element =  $('.js-show-hide-clause'),
            $clauses = $('.js-show-hide-clause-option');

        //console.log('clause')

        //$element.each(function(){
        //    toggleElements.call(this);
        //});

        $element.on('change', function(){
            toggleElements.call(this);
        });

        function toggleElements() {
            var $this = $(this),
                option = $this.val(),
                $field = $('textarea[name="clauses['+option+']"]'),
                $groupField = $field.parent().parent();
            
            $clauses.hide();
            $groupField.show();

        }

    };

}();